import { ErrorHandler, Injectable, Injector } from "@angular/core";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { L10nTranslationService } from "angular-l10n";
import { environment } from "../environments/environment";

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  constructor(private injector: Injector) {
  }

  handleError(error) {
    const router = this.injector.get(Router);
    const toastr = this.injector.get(ToastrService);
    const translation = this.injector.get(L10nTranslationService);

    router.navigateByUrl("/home");
    toastr.error(translation.translate("ERROR.REDIRECTION"), translation.translate("GENERAL.ERROR"), {
      closeButton: true
    });

    if (environment.production) {
      if (error) {
        // TODO --> Error Handler via LogService
      }
    } else {
      throw error;
    }
  }
}
